var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNot = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#000"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.173 29.225h13.659c2.511 0 4.103-2.71 2.84-4.899l-8.43-14.61a1.431 1.431 0 0 0-2.479 0l-8.43 14.61c-1.263 2.186.33 4.899 2.839 4.899h.001Zm8.076-15.128 1.836 3.553 4.43 7.922a.774.774 0 0 1-.681 1.157H21.25V14.095l-.001.002Zm-8.754 11.477 4.427-7.926 1.836-3.551V26.73h-5.583a.774.774 0 0 1-.68-1.157Z",
  fill: "#fff"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNot);
export { ForwardRef as ReactComponent };